// 📦 Import des dépendances
import React from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useMediaQuery } from "@mui/material";

// 🧩 Composant BoutonAjouter
const BoutonAjouterContact = ({ label, onClick, disabled = false }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Button
      type="button" 
      variant="contained"
      display= "flex"
      flexdirection= "column"
      gap= "2"
      onClick={onClick}
      startIcon={<AddIcon sx={{ color: "#fff !important" }} />}
      disabled={disabled}
      sx={{
        color: "#fff",    
        backgroundColor: "#3399FF !important",          
        borderColor: "#3399FF",        
        marginLeft: 1,
        marginTop: 1,
        fontWeight: "bold",
        fontSize: isMobile ? "0.5rem" : "0.7rem",
        transition: "all 0.3s ease",
        minHeight: "48px",
        paddingX: 3,
        paddingY: 2,
        borderRadius: 1,
        '&:hover': {
          backgroundColor: "#3399FF",  // fond au survol
          color: "#fff",               // texte au survol
          }, 
      }}
    >
      {label}
    </Button>
  );
};

export default BoutonAjouterContact;
